/**
 * useSession
 * ----------
 * The stored login (`userData`) as React state, so a component re-renders when
 * the visitor signs in or out rather than only on its next mount. Follows the
 * `arcee:auth-change` event this tab's sign-in and sign-out dispatch, and the
 * `storage` event, so signing out in another tab flips this header too.
 */

import { useEffect, useState } from 'react';
import { retrieve } from '../../utils/storage_helper';

export default function useSession() {
  const [userData, setUserData] = useState(() => retrieve('userData'));

  useEffect(() => {
    const sync = () => setUserData(retrieve('userData'));
    const onStorage = (e) => { if (e.key === null || e.key === 'userData') sync(); };
    window.addEventListener('arcee:auth-change', sync);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('arcee:auth-change', sync);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return userData;
}
